module.exports = __webpack_public_path__ + "img/ty.9dc0e3d6.jpg";